import script from "./briskGroupPicCheckStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./briskGroupPicCheckStatus.vue?vue&type=script&setup=true&lang=js"

import "./briskGroupPicCheckStatus.vue?vue&type=style&index=0&id=2f4c64e5&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f4c64e5"]])

export default __exports__